import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.291 5V3.125l3.75 3.75h-1.875c-1.317 0-1.875-.558-1.875-1.875m4.375 3.125V15q0 2.5-2.5 2.5h-7.5q-2.5 0-2.5-2.5V5q0-2.5 2.5-2.5h4.375V5c0 2.017 1.108 3.125 3.125 3.125zm-4.423 4.136a.6.6 0 0 0-.135-.203L10.44 10.39a.625.625 0 0 0-.884.884l.6.6H7.499a.625.625 0 0 0 0 1.25h2.658l-.6.6a.625.625 0 0 0 .883.884l1.667-1.666a.625.625 0 0 0 .136-.682"
    }, null, -1)
  ])))
}
export default { render: render }